import { ShaderMaterial } from "three"

export class ImageMaterial extends ShaderMaterial {
  constructor(options = {}) {
    super({
      ...options,
      vertexShader: `
      varying vec2 vUv;
      uniform float velocity;

      void main () {
        vUv = uv;
        vec3 nPos = position;

        nPos.y += velocity * 1.35 * ((1.0 - uv.x) - 0.5) * nPos.x;

        gl_Position = projectionMatrix * modelViewMatrix * vec4(nPos.xyz, 1.0);
      }`,
      fragmentShader: `
      varying vec2 vUv;
      uniform sampler2D image;
      uniform float velocity;
      uniform float time;

      void main () {
        vec4 imgColor = texture2D(image, vUv);
        vec4 distorted = texture2D(image, vUv + vec2(0.0, sin(velocity * 0.11)));
        gl_FragColor = vec4(
          imgColor.r * 0.2 + 0.8 * distorted.r,
          imgColor.g * 0.5 + 0.5 * distorted.g,
          imgColor.b * 0.8 + 0.2 * distorted.b,
          imgColor.a
        );
      }`
    })

    this.uniforms = {
      time: { value: 0 },
      velocity: { value: 0 },
      image: { value: options.image }
    }
  }
  set image (v) {
    this.uniforms.image.value = v
  }

  set velocity (v) {
    this.uniforms.velocity.value = v
  }
  get velocity () {
    return this.uniforms.velocity.value
  }

  set time (v) {
    this.uniforms.time.value = v
  }
  get time () {
    return this.uniforms.time.value
  }
}
